import { render, staticRenderFns } from "./EmojiPanel.vue?vue&type=template&id=7f015dff&scoped=true&"
import script from "./EmojiPanel.vue?vue&type=script&lang=js&"
export * from "./EmojiPanel.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPanel.vue?vue&type=style&index=0&id=7f015dff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f015dff",
  null
  
)

export default component.exports